import * as HarryApi from "@atg-horse-shared/harry-api";
import {call, FETCH} from "@atg-shared/fetch-redux";

import type {FetchAction} from "@atg-shared/fetch-types";

// Harry constants
export const RECEIVE_HARRY_BAGS = "RECEIVE_HARRY_BAGS" as const;
export const REQUEST_HARRY_BAGS = "REQUEST_HARRY_BAGS" as const;
export const RECEIVE_HARRY_SUBSCRIPTIONS = "RECEIVE_HARRY_SUBSCRIPTIONS" as const;
export const REQUEST_HARRY_SUBSCRIPTIONS = "REQUEST_HARRY_SUBSCRIPTIONS" as const;
export const RECEIVE_SIMPLE_HARRY = "RECEIVE_SIMPLE_HARRY" as const;
export const REQUEST_SIMPLE_HARRY = "REQUEST_SIMPLE_HARRY" as const;

// Harry Subscription as optional choice constants
export const REQUEST_HARRY_SUBSCRIPTION_AVAILABLE =
    "REQUEST_HARRY_SUBSCRIPTION_AVAILABLE" as const;
export const RECEIVE_HARRY_SUBSCRIPTION_AVAILABLE =
    "RECEIVE_HARRY_SUBSCRIPTION_AVAILABLE" as const;
export const SET_HARRY_SUBSCRIPTION_SELECTED = "SET_HARRY_SUBSCRIPTION_SELECTED" as const;

type SimpleHarryFetchAction = FetchAction<
    typeof REQUEST_SIMPLE_HARRY,
    typeof RECEIVE_SIMPLE_HARRY,
    any
>;

type HarryBagsFetchAction = FetchAction<
    typeof REQUEST_HARRY_BAGS,
    typeof RECEIVE_HARRY_BAGS,
    any
>;

type HarrySubscriptionsFetchAction = FetchAction<
    typeof REQUEST_HARRY_SUBSCRIPTIONS,
    typeof RECEIVE_HARRY_SUBSCRIPTIONS,
    any
>;

type Action =
    | SimpleHarryFetchAction
    | HarryBagsFetchAction
    | HarrySubscriptionsFetchAction;

/**
 * Fetch all upcoming Harry Boy games
 *
 * NOTE: The backend has a built-in filter to prevent the same game type from appearing several
 * times, for some game types.
 */
export const fetchSimpleHarry = (): SimpleHarryFetchAction => ({
    type: FETCH,
    payload: {
        callApi: call(HarryApi.fetchSimpleHarry),
        requestAction: REQUEST_SIMPLE_HARRY,
        receiveAction: RECEIVE_SIMPLE_HARRY,
    },
});

// Harry bags
export const fetchHarryBags = (): HarryBagsFetchAction => ({
    type: FETCH,
    payload: {
        callApi: call(HarryApi.fetchHarryBags),
        requestAction: REQUEST_HARRY_BAGS,
        receiveAction: RECEIVE_HARRY_BAGS,
    },
});

// Harry subscriptions
export const fetchHarrySubscriptions = (): HarrySubscriptionsFetchAction => ({
    type: FETCH,
    payload: {
        callApi: call(HarryApi.fetchHarrySubscriptions),
        requestAction: REQUEST_HARRY_SUBSCRIPTIONS,
        receiveAction: RECEIVE_HARRY_SUBSCRIPTIONS,
    },
});
